import React from "react";

// One human-facing vocabulary for the ID↔BV design loop — mirrors the backend
// DesignLeadStatus enum (the single lifecycle status stored on the lead).
export const PHASE_META = {
  REQUESTED: { label: "Awaiting Designer", className: "bg-blue-100 text-blue-700" },
  ACKNOWLEDGED: { label: "Designing", className: "bg-indigo-100 text-indigo-700" },
  IN_REVIEW: { label: "Under Review", className: "bg-purple-100 text-purple-700" },
  CHANGES_REQUESTED: { label: "Changes Requested", className: "bg-orange-100 text-orange-700" },
  APPROVED: { label: "Awaiting Developer", className: "bg-amber-100 text-amber-700" },
  FINALIZED: { label: "Finalized", className: "bg-emerald-100 text-emerald-700" },
  EXPIRED: { label: "Expired", className: "bg-gray-200 text-gray-600" },
  CANCELLED: { label: "Cancelled", className: "bg-rose-100 text-rose-700" },
};

/** Small pill for a lead's single lifecycle status. Pass the backend `status` value. */
function DesignPhaseBadge({ phase, className = "" }) {
  const meta = PHASE_META[phase];
  if (!meta) return null;
  return (
    <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${meta.className} ${className}`}>
      {meta.label}
    </span>
  );
}

export default DesignPhaseBadge;
